import { theme } from '@adflow/frontend/ui-theme';

export interface FixAddressesToastRow {
	key: string;
	status: 'success' | 'warning' | 'error';
	original: string;
	outcomes: string[];
}

const statusLabels: Record<FixAddressesToastRow['status'], string> = {
	success: 'Success',
	warning: 'Warning',
	error: 'Error',
};

const statusColors: Record<FixAddressesToastRow['status'], string> = {
	success: theme.colors.toasts.success,
	warning: theme.colors.toasts.warning,
	error: theme.colors.toasts.error,
};

interface CreateFixAddressesResultsToastMessageParams {
	statusLabel: string;
	originalLabel: string;
	outcomeLabel: string;
	rows: FixAddressesToastRow[];
}

export function createFixAddressesResultsToastMessage({
	statusLabel,
	originalLabel,
	outcomeLabel,
	rows,
}: CreateFixAddressesResultsToastMessageParams) {
	return (
		<div css={{ overflowX: 'auto' }}>
			<table
				css={{
					width: '100%',
					borderCollapse: 'collapse',
					textAlign: 'left',
					fontFamily: 'inherit',
				}}
			>
				<thead>
					<tr>
						<th
							css={{
								padding: '0.5rem',
								whiteSpace: 'nowrap',
								fontWeight: 700,
							}}
						>
							{statusLabel}
						</th>
						<th
							css={{
								padding: '0.5rem',
								whiteSpace: 'nowrap',
								fontWeight: 700,
							}}
						>
							{originalLabel}
						</th>
						<th
							css={{
								padding: '0.5rem',
								whiteSpace: 'nowrap',
								fontWeight: 700,
							}}
						>
							{outcomeLabel}
						</th>
					</tr>
				</thead>
				<tbody>
					{rows.map((row) => (
						<tr key={row.key}>
							<td
								valign="top"
								css={{
									padding: '0.5rem',
									whiteSpace: 'nowrap',
									color: statusColors[row.status],
								}}
							>
								{statusLabels[row.status]}
							</td>
							<td valign="top" css={{ padding: '0.5rem', minWidth: '15rem' }}>
								{row.original}
							</td>
							<td valign="top" css={{ padding: '0.5rem', minWidth: '15rem' }}>
								<ul css={{ margin: 0 }}>
									{row.outcomes.map((outcome, index) => (
										<li key={`${row.key}-${index}`}>{outcome}</li>
									))}
								</ul>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
